/** Width of the desktop (non-modal) document sidebar, shared with the viewer controls that make room for it. */
const DOCUMENT_PANEL_WIDTH = '26.25rem';

export default DOCUMENT_PANEL_WIDTH;
